import React, { useMemo, useState } from 'react';
import {
  ChildrenMenuWrapper,
  ContentMenu,
  ExpandButton,
  IconDot,
  IconMenu,
  MenuItemChildren,
  MenuItemParent,
  TitleMenu,
  TitleTopPage,
} from 'components/Layout/ApplicationLayout/SidebarMenu/Mobile/Menu/MenuItem/styled';
import { CaretRightOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const MenuItem = ({ menu }) => {
  const navigate = useNavigate();
  const [expand, setExpand] = useState(true);
  const { pathname } = useLocation();

  const regex = /\/[a-z1-9-]+/g;

  // check user click parent menu or children menu
  const selectMenu = () => {
    if (menu.children.length > 0) {
      setExpand(!expand);
      handleNavigateScreen();
    } else {
      handleNavigateScreen();
    }
  };

  // navigate to menu path when user click menu
  const handleNavigateScreen = () => {
    if (menu.path !== '') {
      navigate(menu.path);
    }
  };

  // split path from url
  const CheckLocation = useMemo(() => {
    if (pathname === '' || pathname === '/') {
      return '/';
    } else {
      let check = pathname.match(regex);
      return check[0];
    }
  }, [pathname]);

  // render top page with role Partner Admin, Partner User
  if (menu.isTopPage) {
    return (
      <MenuItemParent
        onClick={selectMenu}
        className={menu.path === CheckLocation ? 'selected' : ''}
      >
        <ContentMenu className="content-menu-responsive">
          <TitleTopPage>{menu.label}</TitleTopPage>
        </ContentMenu>
      </MenuItemParent>
    );
  }
  // render parent menu with icon arrow
  else if (menu.isParent && menu.isTopPage === false) {
    return (
      <>
        <MenuItemParent
          onClick={selectMenu}
          className={menu.path === CheckLocation ? 'selected' : ''}
        >
          <ContentMenu className="content-menu-responsive">
            <IconMenu>{menu.icon}</IconMenu>
            <TitleMenu>{menu.label}</TitleMenu>
          </ContentMenu>
          {menu.children.length > 0 && (
            <ExpandButton className={expand ? 'open' : 'close'}>
              <CaretRightOutlined />
            </ExpandButton>
          )}
        </MenuItemParent>

        <ChildrenMenuWrapper className={expand ? 'show' : 'hide'}>
          {menu.children.map((item) => {
            return <MenuItem menu={item} key={item.id} />;
          })}
        </ChildrenMenuWrapper>
      </>
    );
  }
  // render children menu with icon dot
  else if (menu.isParent === false && menu.isTopPage === false) {
    return (
      <MenuItemChildren
        onClick={selectMenu}
        className={menu.path === CheckLocation ? 'selected' : ''}
      >
        <TitleMenu>
          <ContentMenu className="content-menu-responsive">
            <IconDot
              className={menu.path === CheckLocation ? 'selected' : ''}
            />
            <TitleMenu>{menu.label}</TitleMenu>
          </ContentMenu>
        </TitleMenu>
      </MenuItemChildren>
    );
  }
};

export default MenuItem;
